import React from "react";

// Customizable Area Start
import { styled, Box } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";

import {
  Heading,
  MainContainer,
  WhiteContainer,
  GridContainer,
  BottomContainer,
  TextLabel
} from "./PromotionCreate.web";

import { colors } from "../../../blocks/utilities/src/Colors";
import CustomLoader from "../../../components/src/customComponents/CustomLoader.web";
import { LoadingComponent as LoaderComponent } from "../../../components/src/Loader.web";
// Customizable Area End

import PromotionViewController, {
  // Customizable Area Start
  IPromotionItem,
  IPromotionOfferItem,
  // Customizable Area End
} from "./PromotionViewController.web";

// Customizable Area Start
import { renderBaseOnConditions } from "../../../blocks/utilities/src/CustomBlockHelpers";

const Strings = {
  pageTitle: "Promotion",
  edit: "Edit",
  back: "Back",
  noData: "Data Not Found!",
  
  // Promotion fields
  promotionName: "Promotion Name",
  promotionType: "Promotion Type", 
  promoTextEn: "Promo Item Text (English)",
  promoTextAr: "Promo Item Text (Arabic)",
  discountNameEn: "Order Discount Name (English)",
  discountNameAr: "Order Discount Name (Arabic)",
  
  // Selection fields
  region: "Region",
  area: "Area", 
  section: "Section",
  services: "Services",
  products: "Products",
  platform: "Platform",
  store: "Store",
  
  // Usage fields
  used: "Used",
  noOfOrders: "No. of Orders",
  startDate: "Start Date",
  endDate: "End Date",
  status: "Status",
  
  // Amount fields
  minAmount: "Minimum Order Amount",
  minItems: "Minimum Items",
  
  // Exclusions
  excludedDays: "Excluded Days",
  excludedDates: "Excluded Dates", 
  excludedTimes: "Excluded Times",
  
  // Promotion items
  promotionItems: "Promotion Items",
  promotionOfferItems: "Promotion Offer Items",
  
  // General
  active: "Active",
  inactive: "Inactive",
  currency: "SAR",
  noViewDataString: "----"
};
// Customizable Area End

class PromotionView extends PromotionViewController {
  render() {
    // Customizable Area Start
    const { isLoading, noData, data, permissionStatus } = this.state;
    const {
      promotion_name,
      promotion_type,
      promo_item_text_en,
      promo_item_text_ar,
      order_discount_name_en,
      order_discount_name_ar,
      used,
      status,
      no_of_orders,
      minimum_order_amount,
      minimum_items,
      start_date,
      end_date,
      sections,
      services,
      products,
      platforms,
      regions,
      areas,
      stores,
      excluded_days,
      promotion_items,
      promotion_offer_items,
      excluded_dates,
      excluded_times
    } = data.attributes;

    // Customizable Area End

    return (
      // Customizable Area Start
      <>
       <CustomLoader loading={this.state.isViewLoading}/>
        <MainContainer>
          <HeadingContainer>
            <Heading>{Strings.pageTitle}</Heading>

            <LoaderComponent
              isLoading={this.state.isLoadingPermission}
              height={44}
              width={160}
              disableParentWidth={true}
              isAllowed={permissionStatus.editPermission}
              children={
                <BottomContainer>
                  <button
                    data-test-id='btn-back'
                    onClick={() => this.redirectTo("Promotions")}
                    className='cancel'
                    style={{ marginRight: 16 }}
                  >
                    {Strings.back}
                  </button>
                  <button
                    data-test-id='btn-edit'
                    onClick={() =>
                      this.redirectTo("PromotionEdit", {
                        id: this.props.navigation.getParam("id"),
                      })
                    }
                    className='add'
                  >
                    {Strings.edit}
                  </button>
                </BottomContainer>
              }
            />
          </HeadingContainer>

          {isLoading && !noData && <LoadingComponent />}
          {!isLoading && noData && (
            <span style={{ color: "#EC4E20" }}>{Strings.noData}</span>
          )}
          {!isLoading && !noData && (
            <>
              <WhiteContainer>
                <GridContainer>
                  <div>
                    <TextLabel>{Strings.promotionName}</TextLabel>
                    <ValueText>{promotion_name || Strings.noViewDataString}</ValueText>
                  </div>
                  
                  <div>
                    <TextLabel>{Strings.promotionType}</TextLabel>
                    <ValueText>{promotion_type?.display_name || promotion_type?.name || Strings.noViewDataString}</ValueText>
                  </div>
                  
                  <div>
                    <TextLabel>{Strings.promoTextEn}</TextLabel>
                    <ValueText>{promo_item_text_en || Strings.noViewDataString}</ValueText>
                  </div>
                  
                  <div>
                    <TextLabel>{Strings.promoTextAr}</TextLabel>
                    <ValueText>{promo_item_text_ar || Strings.noViewDataString}</ValueText>
                  </div>
                  
                  <div>
                    <TextLabel>{Strings.discountNameEn}</TextLabel>
                    <ValueText>{order_discount_name_en || Strings.noViewDataString}</ValueText>
                  </div>
                  
                  <div>
                    <TextLabel>{Strings.discountNameAr}</TextLabel>
                    <ValueText>{order_discount_name_ar || Strings.noViewDataString}</ValueText>
                  </div>
                  
                  <div>
                    <TextLabel>{Strings.used}</TextLabel>
                    <ValueText>{used || Strings.noViewDataString}</ValueText>
                  </div>
                  
                  {used === "specific_number_of_orders" && (
                    <div>
                      <TextLabel>{Strings.noOfOrders}</TextLabel>
                      <ValueText>{no_of_orders || Strings.noViewDataString}</ValueText>
                    </div>
                  )}
                  
                  <div>
                    <TextLabel>{Strings.minAmount}</TextLabel>
                    <ValueText>{minimum_order_amount ? `${minimum_order_amount} ${Strings.currency}` : Strings.noViewDataString}</ValueText>
                  </div>
                  
                  <div>
                    <TextLabel>{Strings.minItems}</TextLabel>
                    <ValueText>{minimum_items || Strings.noViewDataString}</ValueText>
                  </div>
                  
                  <div>
                    <TextLabel>{Strings.startDate}</TextLabel>
                    <ValueText>{start_date || Strings.noViewDataString}</ValueText>
                  </div>
                  
                  <div>
                    <TextLabel>{Strings.endDate}</TextLabel>
                    <ValueText>{end_date || Strings.noViewDataString}</ValueText>
                  </div>
                  
                  <div>
                    <TextLabel>{Strings.status}</TextLabel>
                    <ValueText>{status === "active" ? Strings.active : Strings.inactive}</ValueText>
                  </div>
                  
                  <div>
                    <TextLabel>{Strings.region}</TextLabel>
                    <ChipContainer>
                      {regions && regions.length > 0 ? (
                        regions.map((name: string, index: number) => (
                          <StyledChip key={index}>{name}</StyledChip>
                        ))
                      ) : (
                        <ValueText>{Strings.noViewDataString}</ValueText>
                      )}
                    </ChipContainer>
                  </div>
                  
                  <div>
                    <TextLabel>{Strings.area}</TextLabel>
                    <ChipContainer>
                      {areas && areas.length > 0 ? (
                        areas.map((name: string, index: number) => (
                          <StyledChip key={index}>{name}</StyledChip>
                        ))
                      ) : (
                        <ValueText>{Strings.noViewDataString}</ValueText>
                      )}
                    </ChipContainer>
                  </div>
                  
                  <div>
                    <TextLabel>{Strings.section}</TextLabel>
                    <ChipContainer>
                      {sections && sections.length > 0 ? (
                        sections.map((name: string, index: number) => (
                          <StyledChip key={index}>{name}</StyledChip>
                        ))
                      ) : (
                        <ValueText>{Strings.noViewDataString}</ValueText>
                      )}
                    </ChipContainer>
                  </div>
                  
                  <div>
                    <TextLabel>{Strings.services}</TextLabel>
                    <ChipContainer>
                      {services && services.length > 0 ? (
                        services.map((name: string, index: number) => (
                          <StyledChip key={index}>{name}</StyledChip>
                        ))
                      ) : (
                        <ValueText>{Strings.noViewDataString}</ValueText>
                      )}
                    </ChipContainer>
                  </div>
                  
                  <div>
                    <TextLabel>{Strings.platform}</TextLabel>
                    <ChipContainer>
                      {platforms && platforms.length > 0 ? (
                        platforms.map((name: string, index: number) => (
                          <StyledChip key={index}>{name}</StyledChip>
                        ))
                      ) : (
                        <ValueText>{Strings.noViewDataString}</ValueText>
                      )}
                    </ChipContainer>
                  </div>
                  
                  <div>
                    <TextLabel>{Strings.store}</TextLabel>
                    <ChipContainer>
                      {stores && stores.length > 0 ? (
                        stores.map((name: string, index: number) => (
                          <StyledChip key={index}>{name}</StyledChip>
                        ))
                      ) : (
                        <ValueText>{Strings.noViewDataString}</ValueText>
                      )}
                    </ChipContainer>
                  </div>
                  
                  <div>
                    <TextLabel>{Strings.excludedDays}</TextLabel>
                    <ChipContainer>
                      {excluded_days && excluded_days.length > 0 ? (
                        excluded_days.map((day: string, index: number) => (
                          <StyledChip key={index}>{day}</StyledChip>
                        ))
                      ) : (
                        <ValueText>{Strings.noViewDataString}</ValueText>
                      )}
                    </ChipContainer>
                  </div>
                </GridContainer>
                
                {promotion_items && promotion_items.length > 0 && (
                  <>
                    <Spacer32 />
                    <TextLabel>{Strings.promotionItems}</TextLabel>
                    <ItemsContainer>
                      {promotion_items.map((item: IPromotionItem, index: number) => (
                        <ItemBox key={index}>
                          <ItemText>Type: {item.item_type}</ItemText>
                          <ItemText>Product: {item.product_name || item.catalogue?.product_name || "Not selected"}</ItemText>
                          {item.applicable_products_count && (
                            <ItemText>Applicable Products: {item.applicable_products_count}</ItemText>
                          )}
                        </ItemBox>
                      ))}
                    </ItemsContainer>
                  </>
                )}
                
                {promotion_offer_items && promotion_offer_items.length > 0 && (
                  <>
                    <Spacer32 />
                    <TextLabel>{Strings.promotionOfferItems}</TextLabel>
                    <ItemsContainer>
                      {promotion_offer_items.map((item: IPromotionOfferItem, index: number) => (
                        <ItemBox key={index}>
                          <ItemText>Offer Type: {item.offer_type}</ItemText>
                          {item.offer_description && (
                            <ItemText>Description: {item.offer_description}</ItemText>
                          )}
                          {item.item_type && (
                            <ItemText>Item Type: {item.item_type}</ItemText>
                          )}
                          {(item.catalogue?.product_name || item.catalogue_id) && (
                            <ItemText>Product: {item.catalogue?.product_name || "Product ID: " + item.catalogue_id}</ItemText>
                          )}
                        </ItemBox>
                      ))}
                    </ItemsContainer>
                  </>
                )}
                
                {excluded_dates && excluded_dates.length > 0 && (
                  <>
                    <Spacer32 />
                    <TextLabel>{Strings.excludedDates}</TextLabel>
                    <ItemsContainer>
                      {excluded_dates.map((item: any, index: number) => (
                        <ItemBox key={index}>
                          <ItemText>Date: {item.display_date || item.excluded_date}</ItemText>
                          {item.reason && (
                            <ItemText>Reason: {item.reason}</ItemText>
                          )}
                        </ItemBox>
                      ))}
                    </ItemsContainer>
                  </>
                )}
                
                {excluded_times && excluded_times.length > 0 && (
                  <>
                    <Spacer32 />
                    <TextLabel>{Strings.excludedTimes}</TextLabel>
                    <ItemsContainer>
                      {excluded_times.map((item: any, index: number) => (
                        <ItemBox key={index}>
                          <ItemText>Time Range: {item.display_range || `${item.start_time} - ${item.end_time}`}</ItemText>
                        </ItemBox>
                      ))}
                    </ItemsContainer>
                  </>
                )}
              </WhiteContainer>
            </>
          )}
        </MainContainer>
      </>
      // Customizable Area End
    );
  }
}

// Customizable Area Start
const HeadingContainer = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "32px",
  flexWrap: "wrap"
});

const ValueText = styled("div")({
  fontSize: "16px",
  lineHeight: "24px",
  fontWeight: 400,
  color: "#4D4D4D",
  marginTop: "8px"
});

const ChipContainer = styled("div")({
  display: "flex",
  flexWrap: "wrap",
  gap: "8px",
  marginTop: "8px"
});

const StyledChip = styled("div")({
  padding: "4px 12px",
  backgroundColor: "#F1F5F9",
  borderRadius: "16px",
  fontSize: "14px",
  color: "#475569",
  border: "1px solid #E2E8F0"
});

const Spacer32 = styled("div")({
  height: "32px"
});

const LoadingComponent = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "200px",
  fontSize: 16,
  color: "#204B9C",
});

const ItemsContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: "12px",
  marginTop: "16px"
});

const ItemBox = styled("div")({
  padding: "16px",
  border: "1px solid #E2E8F0",
  borderRadius: "8px",
  backgroundColor: "#F8FAFC"
});

const ItemText = styled("div")({
  fontSize: "14px",
  lineHeight: "20px",
  color: "#475569",
  marginBottom: "4px",
  "&:last-child": {
    marginBottom: 0
  }
});
// Customizable Area End

export default PromotionView;